import { render } from "./modal-edit-tresholnilai.vue?vue&type=template&id=a9b83712&scoped=true"
import script from "./modal-edit-tresholnilai.vue?vue&type=script&lang=js"
export * from "./modal-edit-tresholnilai.vue?vue&type=script&lang=js"

import "./modal-edit-tresholnilai.vue?vue&type=style&index=0&id=a9b83712&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9b83712"]])

export default __exports__